import I18n from '@utils/i18n.utils';
import {IssueKindType} from '@store/operations/issues';

export enum IssueAudienceKindEnum {
  SUPPLIER = 'SUPPLIER',
  CLIENT = 'CLIENT',
}

export namespace IssueAudienceKindEnum {
  export const selectItems = () => [
    {label: I18n.t('global.supplier'), value: IssueAudienceKindEnum.SUPPLIER},
    {label: I18n.t('global.client'), value: IssueAudienceKindEnum.CLIENT},
  ];
}

export interface IssueKind {
  name: string;
  translationKey: string;
  audienceKind: IssueAudienceKindEnum;
  id: number;
  type: IssueKindType;
}
